// 日期格式化
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

//音视频时长时间格式化(00:00:00)格式 参数:秒
export function secondsToTime(time) {
  if (!time) {
    return "00:00:00";
  }
  var hours = Math.floor(time / 3600) % 24,
    minutes = Math.floor(time / 60) % 60,
    seconds = Math.floor(time % 60),
    // result =
    //   (hours > 0 ? (hours < 10 ? "0" + hours : hours) + ":" : "") +
    //   (minutes < 10 ? "0" + minutes : minutes) +
    //   ":" +
    //   (seconds < 10 ? "0" + seconds : seconds);
    result =
      (hours < 10 ? "0" + hours : hours) +
      ":" +
      (minutes < 10 ? "0" + minutes : minutes) +
      ":" +
      (seconds < 10 ? "0" + seconds : seconds);

  return result;
}

// 时间转化成秒

export function formatSeconds(value) {
  var hour = value.split(":")[0];
  var min = value.split(":")[1];
  var sec = value.split(":")[2];
  var result = Number(hour * 3600) + Number(min * 60) + Number(sec);
  return result;
}

// 中国标准时间转化为 时分秒

export function transformTime(date) {
  var d = new Date(date);
  var datetime = d.getHours() + ":" + d.getMinutes() + ":" + d.getSeconds();
  return datetime;
}

// 中国标准时间转化为 年月日
export function transformDayTime(date) {
  var d = new Date(date);
  var datetime = d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
  return datetime;
}

// 日期（2022-7-1 22：10：20）转化为时间戳
export function datetimeToUnix(date) {
  var tmp_datetime = date.replace(/:/g, "-");
  tmp_datetime = tmp_datetime.replace(/ /g, "-");
  var arr = tmp_datetime.split("-");
  var now = new Date(
    Date.UTC(arr[0], arr[1] - 1, arr[2], arr[3] - 8, arr[4], arr[5])
  );
  return parseInt(now.getTime() / 1000);
}

// 时间差计算
export function timeDifferent(beginTime, endTime) {
  var dateBegin = new Date(beginTime);
  var dateEnd = new Date(endTime);
  var dateDiff = dateEnd.getTime() - dateBegin.getTime(); //时间差的毫秒数
  var dayDiff = Math.floor(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
  var leave1 = dateDiff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数
  var hours = Math.floor(leave1 / (3600 * 1000)); //计算出小时数
  //计算相差分钟数
  var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数
  var minutes = Math.floor(leave2 / (60 * 1000)); //计算相差分钟数
  //计算相差秒数
  var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数
  var seconds = Math.round(leave3 / 1000);
  console.log(
    "相差" + dayDiff + "天" + hours + "小时" + minutes + "分钟" + seconds + "秒"
  );
  return hours * 60 * 60 + minutes * 60 + seconds;
}

// 年月日时分
export function parseTimeNoSecond(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = pattern || "{y}-{m}-{d} {h}:{i}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (typeof time === "string" && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    } else if (typeof time === "string") {
      time = time.replace(new RegExp(/-/gm), "/");
    }
    if (typeof time === "number" && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === "a") {
      return ["日", "一", "二", "三", "四", "五", "六"][value];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

//手机号校验规则，return Boolean
export function validateMobile(str) {
  const reg = /^1[3-9]\d{9}$/;
  return reg.test(str);
}

// 年月日时分
export function parseTimeToDate(timestamp) {
  if (!timestamp) {
    return "--";
  }
  const date = new Date(timestamp * 1000);
  const year = date.getFullYear();
  const month = date.getMonth() + 1; // 注意：月份从0开始，所以要加1
  const day = date.getDate();

  const formattedDate = `${year}/${month < 10 ? "0" : ""}${month}/${
    day < 10 ? "0" : ""
  }${day}`;
  return formattedDate;
}
